import React from "react";
import Head from 'next/head';
import logo from '/public/static/images/image_logo_full.svg';

interface IMetaTag {
    name: string;
    content: string;
}
interface IHSGenerate {
    title: string;
    metas?: IMetaTag[] | undefined
}
interface IInitialMetas {
    key: string;
    value: string;
}
interface IHeadService {
    manualBuild: (title: IHSGenerate['title'], metas: IHSGenerate['metas']) => React.JSX.Element;
    simpleBuild: (title: string, currentUrl: string | undefined, additionalMetas?: IInitialMetas[]) => React.JSX.Element;
    generateMetas: (array: IInitialMetas[]) => React.JSX.Element;
    initialMetas: IInitialMetas[]
}

const HeadService: IHeadService = {
    manualBuild: function(title, metas) {
        return (
            <Head>
                <title>{title}</title>
                {metas && metas.length > 0 && metas.map((tag: IMetaTag) => (
                    <meta
                        name={tag.name}
                        content={tag.content}
                    />
                ))}
            </Head>
        )
    },
    simpleBuild: function(title, currentUrl = '', additionalMetas = []) {
        const tags = [
            ...this.initialMetas,
            {
                key: 'og:title',
                value: `${title} - TKMP.Istok`
            },
            {
                key: 'og:url',
                value: `${process.env.NEXT_PUBLIC_DOMAIN}${currentUrl}`
            },
            ...additionalMetas
        ]

        return (
            <Head>
                <title>{title}</title>
                {this.generateMetas(tags)}
            </Head>
        )
    },
    generateMetas: function(array) {
        return (
            <>
                {array.map((tag: IInitialMetas) => tag.key.includes('og:')
                    ? <meta
                        property={tag.key}
                        content={tag.value}
                    ></meta>
                    : <meta
                        name={tag.key}
                        content={tag.value}
                    ></meta>
                )}
            </>
        )
    },
    initialMetas: [
        {
            key: 'description',
            value: 'TKMP.Istok - ваш надежный B2B маркетплейс для поиска поставщиков и закупок товаров. Присоединяйтесь к нашим миллионам пользователей!'
        },
        {
            key: 'keywords',
            value: 'каталог, товары, B2B, маркетплейс, закупки, поставщики, TKMP.Istok'
        },
        {
            key: 'author',
            value: 'Команда TKMP.Istok'
        },
        {
            key: 'og:title',
            value: `TKMP.Istok`
        },
        {
            key: 'og:description',
            value: 'Найдите идеальные товары для вашего бизнеса на TKMP.Istok.'
        },
        {
            key: 'og:url',
            value: `${process.env.NEXT_PUBLIC_DOMAIN}`
        },
        {
            key: 'og:image',
            value: logo.src
        },
        {
            key: 'og:type',
            value: 'website'
        },
        {
            key: 'twitter:card',
            value: 'summary_large_image'
        },
        {
            key: 'twitter:title',
            value: 'TKMP.Istok - B2B Маркетплейс для Бизнеса'
        },
        {
            key: 'twitter:description',
            value: 'Узнайте, как TKMP.Istok может помочь в ваших закупках и продажах!'
        },
        {
            key: 'twitter:image',
            value: logo.src
        }
    ]
}

export default HeadService;